<div class="@container nrc-image-container relative w-full h-full">
  <!-- Error state - only show when main image fail or thumbnail is available and failed to load -->
  @if (hasError() || (!!thumbnail && hasThumbnailError())) {
    <div class="absolute inset-0 flex flex-col gap-2 items-center justify-center w-full h-full bg-gray-100 bg-opacity-10">
      <nrc-icon class="block w-6 h-7" [name]="'info-outline'"/>
      <p class="text-sm text-center @[5rem]:block hidden">Unable to load image</p>
    </div>
    }

  <!-- Show loading when main image is loading and no thumbnail is available -->
  @if ((!isLoaded() && !hasError()) && !thumbnail) {
    <div class="absolute inset-0 bg-theme-background rounded-md">
      <nrc-loading-spinner class="absolute w-full h-full flex items-center justify-center" />
    </div>
  }

  <!-- Show thumbnail when it is loaded and main image is not loaded -->
  @if (!isLoaded() && !!thumbnail && !hasThumbnailError() && isThumbnailLoaded()) {
    <img
      #thumbnailImage
      class="absolute w-full h-full object-cover z-10"
      [alt]="alt ?? ''"
      [class.rounded-md]="isRounded"
      [ngSrc]="thumbnail.uri"
      [draggable]="false"
      [priority]="true"
      [fill]="true"
      (error)="onThumbnailError()"
    />
  }

  <!-- Main image (always in DOM, fades in when loaded) -->
  @if (source) {
    <img
      #mainImage
      class="absolute w-full h-full object-cover transition-opacity duration-250 ease-in"
      [ngClass]="{
        'bg-transparent-dark': !isTransparent,
        'object-cover': objectFit === 'cover',
        'object-contain': objectFit === 'contain',
        'rounded-md': isRounded,
        'opacity-100': isLoaded() && !hasError(),
        'opacity-0': !isLoaded() || hasError()
      }"
      [ngSrc]="source.uri"
      [alt]="alt ?? ''"
      [draggable]="false"
      [priority]="priority"
      [fill]="true"
      (error)="onError()"
    />
  }
</div>
